var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-steps',{attrs:{"active":_vm.active,"align-center":""}},_vm._l((_vm.stepsText),function(item,index){return _c('el-step',{key:index,attrs:{"title":item.title,"description":item.description}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }